import intl from 'react-intl-universal';
import logger from 'utils/logger';
import { USER_DATA } from 'shared/constants/users';

const log = logger.createLogger('intl');

export const LANGUAGE_CODE = {
  ENGLISH: 'en-US',
  CHINESE: 'zh-CN',
  JAPANESE: 'ja-JP',
  INDONESIAN: 'id-ID',
};

export const getText = (text) => {
  try {
    // Suppress warnings for missing keys by temporarily overriding console.warn
    const originalWarn = console.warn;
    console.warn = () => {}; // Suppress warnings

    const textValue = intl.get(text);

    // Restore original console.warn
    console.warn = originalWarn;

    if (textValue && textValue !== text) {
      return textValue;
    }
    return text;
  } catch (_) {
    // Silently return the original text if translation fails
    return text;
  }
};

export const getCurrentLocale = () => {
  let locale = queryLocalCode(
    localStorage.getItem(USER_DATA.PREFFERED_LANGUAGE)
  );
  if (!locale) {
    log.warn('LOCALE not found in the local storage');
    locale = getLocaleFromBrowser();
  }
  return locale;
};

export const queryLocalCode = (lang) => {
  if (lang) {
    if (lang.startsWith('en')) {
      return LANGUAGE_CODE.ENGLISH;
    }
    if (lang.startsWith('zh')) {
      return LANGUAGE_CODE.CHINESE;
    }
    if (lang.startsWith('ja')) {
      return LANGUAGE_CODE.JAPANESE;
    }
    if (lang.startsWith('id')) {
      return LANGUAGE_CODE.INDONESIAN;
    }
  }
  return null;
};

export const getLocaleFromBrowser = () => {
  const locale = navigator.language;
  if (locale.startsWith('en')) {
    return LANGUAGE_CODE.ENGLISH;
  }
  if (locale.startsWith('zh')) {
    return LANGUAGE_CODE.CHINESE;
  }
  if (locale.startsWith('ja')) {
    return LANGUAGE_CODE.JAPANESE;
  }
  if (locale.startsWith('id')) {
    return LANGUAGE_CODE.INDONESIAN;
  }
  log.warn('LOCALE not found in our supported list', locale);
  return LANGUAGE_CODE.JAPANESE;
};

export const initLocale = async (currentLocale) => {
  // Temporarily suppress console.warn to avoid react-intl-universal warnings
  const originalWarn = console.warn;
  console.warn = (...args) => {
    // Filter out react-intl-universal warnings
    if (
      args[0] &&
      typeof args[0] === 'string' &&
      args[0].includes('react-intl-universal key')
    ) {
      return; // Suppress the warning
    }
    originalWarn.apply(console, args);
  };

  try {
    await intl.init({
      currentLocale,
      locales: {
        [LANGUAGE_CODE.ENGLISH]: import.meta.glob('../locales/en-US.json', {
          eager: true,
        })['../locales/en-US.json'].default,
        [LANGUAGE_CODE.CHINESE]: import.meta.glob('../locales/zh-CN.json', {
          eager: true,
        })['../locales/zh-CN.json'].default,
        [LANGUAGE_CODE.JAPANESE]: import.meta.glob('../locales/ja-JP.json', {
          eager: true,
        })['../locales/ja-JP.json'].default,
        [LANGUAGE_CODE.INDONESIAN]: import.meta.glob('../locales/id-ID.json', {
          eager: true,
        })['../locales/id-ID.json'].default,
      },
    });
  } finally {
    // Restore original console.warn
    console.warn = originalWarn;
  }
};

export default intl;
